import { apiUrl } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';
import toast, { Toaster } from "react-hot-toast"

export const getTerminals = async (filters = {}) => {
    const token = await UserProfile.getToken();
    const response = await axios.get(`${apiUrl}admin/terminals`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: filters
    });
    return response
};